var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isFullWidth
    ? _c("div", [
        _c("div", { staticClass: "fixed-grid has-12-cols" }, [
          _c("div", { staticClass: "grid" }, [
            _c("div", { staticClass: "cell is-col-span-6" }, [
              _c("div", { staticClass: "fixed-grid has-12-cols" }, [
                _c("div", { staticClass: "grid" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "cell is-col-span-10 is-flex is-flex-direction-column",
                    },
                    [_vm._t("description")],
                    2
                  ),
                  _c("div", { staticClass: "cell" }, [_vm._t("part_type")], 2),
                  _c(
                    "div",
                    { staticClass: "cell is-clickable" },
                    [_vm._t("report")],
                    2
                  ),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "cell is-col-span-4" },
              [
                _c("div", { staticClass: "fixed-grid has-12-cols" }, [
                  _c("div", { staticClass: "grid" }, [
                    _c(
                      "div",
                      { staticClass: "cell is-col-span-2" },
                      [_vm._t("part_qty")],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "cell is-col-span-3" },
                      [_vm._t("part_sell")],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "cell is-col-span-3" },
                      [_vm._t("part_markup")],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "cell is-col-span-3" },
                      [_vm._t("part_buy")],
                      2
                    ),
                  ]),
                ]),
                _vm._t("part_qty_values"),
              ],
              2
            ),
            _c("div", { staticClass: "cell is-col-span-2" }, [
              _c("div", { staticClass: "fixed-grid has-12-cols" }, [
                _c("div", { staticClass: "grid" }, [
                  _c(
                    "div",
                    { staticClass: "cell is-col-span-5" },
                    [_vm._t("total_value")],
                    2
                  ),
                  _c("div", { staticClass: "cell is-col-span-7" }, [
                    _c(
                      "div",
                      { staticClass: "cell end is-align-items-center" },
                      [
                        _c(
                          "div",
                          { staticClass: "mt-1 is-flex" },
                          [
                            _vm._t("comment"),
                            _vm._t("assessment_status"),
                            _vm._t("part_status"),
                            _vm._t("delete_button"),
                            _vm._t("drag_button"),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ])
    : _c("div", { staticClass: "fixed-grid has-12-cols" }, [
        _c("div", { staticClass: "grid", staticStyle: { "row-gap": "5px" } }, [
          _c("div", { staticClass: "cell is-col-span-7" }, [
            _c("div", { staticClass: "fixed-grid has-12-cols" }, [
              _c("div", { staticClass: "grid" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "cell is-col-span-8 is-flex is-flex-direction-column",
                  },
                  [_vm._t("description")],
                  2
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "cell is-col-span-3 is-flex is-justify-content-center",
                  },
                  [_vm._t("part_type")],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "cell is-flex" },
                  [_vm._t("report")],
                  2
                ),
              ]),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "cell",
              class: { "is-align-content-center": _vm.isHeader },
            },
            [_vm._t("part_qty")],
            2
          ),
          _c("div", { staticClass: "cell is-col-span-4" }, [
            _c("div", { staticClass: "fixed-grid has-12-cols" }, [
              _c("div", { staticClass: "grid" }, [
                _c(
                  "div",
                  {
                    staticClass: "cell is-col-span-5",
                    class: { "is-align-content-center": _vm.isHeader },
                  },
                  [_vm._t("total_value")],
                  2
                ),
                _c("div", { staticClass: "cell is-col-span-7 end" }, [
                  _c(
                    "div",
                    { staticClass: "is-flex mt-2" },
                    [
                      _vm._t("comment"),
                      _vm._t("assessment_status"),
                      _vm._t("part_status"),
                      _vm._t("delete_button"),
                      _vm._t("drag_button"),
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm.isFullyExpanded && _vm.isSupportUser
            ? _c(
                "div",
                { staticClass: "cell is-col-span-1" },
                [_vm._t("lineNo")],
                2
              )
            : _vm._e(),
          _vm.isFullyExpanded && _vm.isSupportUser
            ? _c(
                "div",
                { staticClass: "cell is-col-span-1" },
                [_vm._t("itemNo")],
                2
              )
            : _vm._e(),
          _vm.isFullyExpanded && _vm.isSupportUser
            ? _c(
                "div",
                { staticClass: "cell is-col-span-1" },
                [_vm._t("itemStatus")],
                2
              )
            : _vm._e(),
          _vm.isFullyExpanded
            ? _c("div", { staticClass: "cell is-col-span-2" })
            : _vm._e(),
          _vm.isFullyExpanded && !_vm.isSupportUser
            ? _c(
                "div",
                { staticClass: "cell is-col-span-3" },
                [_vm._t("empty_slot")],
                2
              )
            : _vm._e(),
          _vm.isFullyExpanded
            ? _c("div", { staticClass: "cell is-col-span-2" }, [
                _c(
                  "div",
                  { staticStyle: { "margin-top": "-22px" } },
                  [
                    _c("span", { staticClass: "has-text-weight-bold ml-2" }, [
                      _vm._v("Unit Price:"),
                    ]),
                    _vm._t("part_sell"),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _vm.isFullyExpanded
            ? _c("div", { staticClass: "cell is-col-span-2" }, [
                _c(
                  "div",
                  { staticStyle: { "margin-top": "-22px" } },
                  [
                    _c("span", { staticClass: "has-text-weight-bold ml-2" }, [
                      _vm._v("Mark up:"),
                    ]),
                    _vm._t("part_markup"),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _vm.isFullyExpanded
            ? _c("div", { staticClass: "cell is-col-span-2" }, [
                _c(
                  "div",
                  { staticStyle: { "margin-top": "-22px" } },
                  [
                    _c("span", { staticClass: "has-text-weight-bold ml-2" }, [
                      _vm._v("Buy Price:"),
                    ]),
                    _vm._t("part_buy"),
                  ],
                  2
                ),
              ])
            : _vm._e(),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }